import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";
import { UserDataContext } from "src/contexts/userData.tsx";

export const useUserData = () => useContextOrThrow(UserDataContext);
